const YoastFaq = ($) => {
  var yoast = {
    accordion: function () {
      $(".wp-block-yoast-faq-block")
        .find(".schema-faq-question")
        .click(function () {
          //Expand or collapse this panel
          $(this)
            .nextAll(".schema-faq-answer")
            .eq(0)
            .slideToggle("fast", function () {
              if ($(this).hasClass("collapse")) {
                $(this).removeClass("collapse");
              } else {
                $(this).addClass("collapse");
              }
            });

          //Hide the other panels
          $(".schema-faq-answer")
            .not($(this).nextAll(".schema-faq-answer").eq(0))
            .slideUp("fast");
        });

      $('.wp-block-yoast-faq-block .schema-faq-question').click(function(){
        $('.wp-block-yoast-faq-block .schema-faq-question').not( $(this) ).removeClass('collapse');
        if( $(this).hasClass('collapse') ){
          $(this).removeClass('collapse');
        }
        else{
          $(this).addClass('collapse');
        }
      });

      $(".wp-block-yoast-faq-block .schema-faq-question")
        .attr("tabIndex", "0")
        .attr("role", "button")
        .on("keydown", (e) => {
          var code = e.which;
          // 13 = Return, 32 = Space
          if (code === 13 || code === 32) {
            $(e.currentTarget).click();
          }
        });
    },
  };

  yoast.accordion();
};

export default YoastFaq;
